<main class="rayalina-auth-shell rayalina-auth-shell--split">
    <aside class="auth-aside" aria-label="À propos de Rayalina">
        <div class="auth-aside__brand">
            <h2 class="auth-aside__title">Reprenez là où vous en étiez.</h2>
            <p class="auth-aside__lead">
                Connexion rapide pour accéder à votre espace, finaliser une souscription ou reprendre un paiement mobile.
            </p>
            <ul class="auth-aside__points">
                <li><i class="bx bx-lock-alt" aria-hidden="true"></i> Session sécurisée</li>
                <li><i class="bx bx-wallet" aria-hidden="true"></i> Tarifs en MGA, mobile money au checkout</li>
                <li><i class="bx bx-time-five" aria-hidden="true"></i> Quelques secondes pour vous identifier</li>
            </ul>
        </div>
    </aside>
    <div class="auth-main">
        <div class="auth-main__inner">
            <div class="auth-card">
                <header class="auth-card-header">
                    <h1 class="auth-title">Connexion</h1>
                    <p class="auth-sub">
                        Pas encore de compte ?
                        <a routerLink="/auth/signup" [queryParams]="{ returnUrl: returnUrl }">Créer un compte</a>
                    </p>
                </header>
                <ng-container *ngIf="socialEnabled">
                    <app-rayalina-social-login (success)="onAuthenticated()"></app-rayalina-social-login>
                    <div class="auth-divider">
                        <span>ou par email</span>
                    </div>
                </ng-container>
                <app-rayalina-login-form
                    [returnUrl]="returnUrl"
                    (success)="onAuthenticated()"
                ></app-rayalina-login-form>
            </div>
        </div>
    </div>
</main>
